import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CollectionItem from "../Item/CollectionItem";

const Collections = () => {
    const [items, setItems] = useState([]);
    useEffect(() => {
        axios.get(`/collections?pageLimit=8&page=1`)
            .then(res => {
                setItems(res.data.collections);
            }).catch(e => {
                console.log(e);
                setItems([]);
            })
    }, []);
    return (
        <section className="popular-collections-area">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {/* Intro */}
                        <div className="intro d-flex justify-content-between align-items-end m-0">
                            <div className="intro-content">
                                <span>Most Popular</span>
                                <h3 className="mt-3 mb-0">Popular Collections</h3>
                            </div>
                            <div className="intro-btn mb-2">
                                <a className="btn content-btn text-left" href="/explore/collections">Explore More</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row items">
                    {items.map((item, idx) => {
                        return (
                            <div key={`cd_${idx}`} className="col-12 col-sm-6 col-md-4 col-lg-3 item">
                                <CollectionItem collection={item} />
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default Collections;
